import { useEffect, useRef } from 'react'
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'
import { init } from 'emoji-mart'

const EmojiPicker = (props: any) => {
	const { onChange, onClickOutside } = props

	useEffect(() => {
		init({ data })
	}, [])

	const onEmojiSelect = (e: any) => {
		onChange(e)
	}
	const onClickOutsideHandler = () => {
		if (!!onClickOutside) onClickOutside()
	}

	return (
		<Picker
			data={data}
			onEmojiSelect={(e: any) => onEmojiSelect(e)}
			onClickOutside={() => onClickOutsideHandler()}
		/>
	)
}

export default EmojiPicker
